import React from 'react'

const GenderCard = ({ male, female, other }) => {
  // Total number of icons to display
  const totalIcons = 10

  // Calculate the number of icons for each gender
  const maleIcons = Math.round((male / 100) * totalIcons)
  const femaleIcons = Math.round((female / 100) * totalIcons)
  const otherIcons = 1 // You can adjust this based on your needs

  // Generate icons for each category
  const maleIconsList = []
  const femaleIconsList = []
  const otherIconsList = []

  for (let i = 0; i < maleIcons; i++) {
    maleIconsList.push(<i key={`male-${i}`} className="fa-solid fa-person text-6xl text-pointed"></i>)
  }

  for (let i = 0; i < femaleIcons; i++) {
    femaleIconsList.push(<i key={`female-${i}`} className="fa-solid fa-person text-6xl text-error"></i>)
  }

  for (let i = 0; i < otherIcons; i++) {
    otherIconsList.push(<i key={`other-${i}`} className="fa-solid fa-person text-6xl text-tl_purple"></i>)
  }

  return (
    <div className="bg-white p-4 lg:p-12 rounded-[40px] tl-shadow">
      <h2 className="text-lg font-semibold mb-12">Candidates by gender</h2>
      <div className="mb-12">
        <div className="mb-4">
          <span>{male}% Men</span>
        </div>
        <div className="mb-4">
          <span>{female}% Women</span>
        </div>
        <div className="mb-4">
          <span>{other}% Other</span>
        </div>
      </div>
      <div className="flex items-left justify-left">
        <div className="flex flex-col items-start">
          <div className="mb-8">{maleIconsList}</div>
          <div className="mb-8">{femaleIconsList}</div>
          <div className="mb-8">{otherIconsList}</div>
        </div>
      </div>
    </div>
  )
}

export default GenderCard
